import React, { Component } from 'react';
import './App.css';
import PlayerControls from './PlayerControls';
import NowPlaying from './NowPlaying';
import RecentlyPlayed from './RecentlyPlayed';
import nowplaying from './images/nowplaying.png';
import AmazonLink from './AmazonLink';
import IcecastNowPlaying from './IcecastNowPlaying';

import AlbumArt from './AlbumArt';
import $ from 'jquery';

const default_album_art = 'https://albumart.customchannels.net/default-album-art.png';

class App extends Component {

  constructor (props){
    super(props);

    this.state = {
      nowplaying: {
        title: "Title",
        artist: 'Artist',
        album: "Album",
        album_art: { large: default_album_art }},
      tracks: []
    };
  }

  setTrackData(data){
    let tracks = data.data.slice();
    let nowplaying = tracks[0];
    tracks.shift();

    this.setState({
      nowplaying: nowplaying,
      tracks: tracks
    });

    $('.album-art img').attr('src', nowplaying.album_art.large);
  }

  componentWillMount(){
      // get the now playing
      const nowplaying = new IcecastNowPlaying(222, 'http://stream.customchannels.net/floyds_96.mp3');
      nowplaying.checkIcecast((data) => {
        this.setTrackData(data);
      });

      setInterval(() => {
        nowplaying.checkIcecast((data) => {
          this.setTrackData(data);
        })
      }, 15000);
  }

  render() {
    return (
      <div className="App">

          <div className="album-art-background" style={{ backgroundImage : `url('${this.state.nowplaying.album_art.large}')` }}>
            <div className="now-playing-container">

                <div>
                    <div className="album-art">
                        <AlbumArt albumArtUrl={ this.state.nowplaying.album_art.small } album={ this.state.nowplaying.album } />
                    </div>
                </div>

                <div id="track-info">
                    <div className="now-playing-text floyds-yellow-text">Now Playing</div>
                    <div className="NowPlaying">
                        <span className="now-playing-title-album floyds-red-text">"{ this.state.nowplaying.title }" - { this.state.nowplaying.album }</span><br />
                        <span className="now-playling-artist">{ this.state.nowplaying.artist }</span>
                    </div>
                    <PlayerControls />
                </div>

                <div className="now-playing-right">
                    <a id="cc-logo" href="http://customchannels.net?utm_source=Floyds99&utm_medium=Custom%20Channels%20Logo&utm_campaign=Floyds%20Web%20Player" target="_blank">
                        <img src="images/customchannels.png" alt="Custom Channels" height="46" width="294" />
                    </a>
                    <div style={{ float : "right" }}>
                        <AmazonLink artist={ this.state.nowplaying.artist } title={ this.state.nowplaying.title } />
                    </div>
                </div>
            </div>
          </div>

          <div className="clear">&nbsp;</div>

          <h1 className="floyds-blue floyds-black-text" style={{ margin: 0, padding: "10px" }}>RECENTLY PLAYED</h1>
          <RecentlyPlayed tracks={ this.state.tracks } />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js